import { render, staticRenderFns } from "./bank-accounts.vue?vue&type=template&id=3787c36c&scoped=true&"
import script from "./bank-accounts.vue?vue&type=script&lang=js&"
export * from "./bank-accounts.vue?vue&type=script&lang=js&"
import style0 from "./bank-accounts.vue?vue&type=style&index=0&id=3787c36c&prod&lang=css&"
import style1 from "./bank-accounts.vue?vue&type=style&index=1&id=3787c36c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3787c36c",
  null
  
)

export default component.exports